// @react/hooks/useProjectItem.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectItemStore } from '@core/stores';

/**
 * React hook for ProjectItem operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectItem } from '@react/hooks';
 *
 * const ProjectItemList = observer(() => {
 *   const store = useProjectItem();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectItem() {
  return projectItemStore;
}
